module.exports = __webpack_public_path__ + "img/7.26d825d8.svg";